// extracted by mini-css-extract-plugin
export default {"typeWrapper":"RenderPaymentMethods_typeWrapper__6An2f","selected":"RenderPaymentMethods_selected__x0Zi-","radioButton":"RenderPaymentMethods_radioButton__K48qy"};